import { Client } from "../../../client";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { toast } from "react-toastify";
import { proccessErrorMessage } from "../../../Helper/proccessErrorMessage";
import { API_CLOSE_INDIVIDUAL_INVESTMENTS } from "../../../config/api";

export const individualInvestmentCloseOut = createAsyncThunk(
  "individualInvestmentCloseOut/close",
  async ({ data, callback, fail }, { dispatch, rejectWithValue }) => {
    try {
      const response = await Client({
        method: "POST",
        path: API_CLOSE_INDIVIDUAL_INVESTMENTS,
        data: data,
      });
      toast.success(response?.data?.message);
      callback();
    } catch (error) {
      const msg = proccessErrorMessage(error);
      toast.error(msg || "Error processing payout ");
      if (fail) {
        fail();
      }
      return rejectWithValue(error.message);
    }
  },
);
